import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { checkLogin, setOtpVerified } from '../../Common/store';
import { terminalLogout } from '../api/cp';
import { LogOut, Settings } from 'lucide-react';
import AppLogoutConfirmModal from '../components/AppLogoutConfirmModal';
import AppDashboard from './AppDashboard';
import AppDashboard_1 from './AppDashboard_1';
import { getAppLogoAssetUrl, getAppLogoFallbackUrl, getAppHeaderLogoStyle } from '../../Common/constants/adminImages';

/** dev URL이면 AppDashboard_1, 아니면 AppDashboard (수기결제와 동일한 방식) */
// const isDevUrl = false;
const isDevUrl = typeof window !== 'undefined' && window.location.href.includes('dev');

/**
 * 앱 대시보드 - URL에 dev 포함 시 AppDashboard_1, 아니면 AppDashboard
 */
function AppDashboardPage() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [logoutModalOpen, setLogoutModalOpen] = useState(false);
    const [logoutLoading, setLogoutLoading] = useState(false);

    const confirmLogout = async () => {
        try {
            setLogoutLoading(true);
            try {
                await terminalLogout();
            } catch (e) {}
            dispatch(setOtpVerified(false));
            dispatch(checkLogin(false));
            setLogoutModalOpen(false);
            navigate('/app');
        } finally {
            setLogoutLoading(false);
        }
    };

    return (
        <div style={{
            height: '100dvh',
            minHeight: '100dvh',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            maxWidth: '768px',
            margin: '0 auto',
            background: '#FFFFFF',
            overflow: 'hidden',
        }}>
            <style>
                {`
                    button, a, [onClick] {
                        outline: none !important;
                        -webkit-tap-highlight-color: transparent;
                        -webkit-touch-callout: none;
                        user-select: none;
                        transition: transform 0.1s ease, opacity 0.1s ease;
                    }
                    button:focus, a:focus, [onClick]:focus { outline: none !important; }
                    button:active, a:active, [onClick]:active {
                        outline: none !important;
                        transform: scale(0.96);
                        opacity: 0.8;
                    }
                `}
            </style>

            {/* 헤더: 로그아웃(왼쪽) | 로고(가운데) */}
            <div style={{
                background: 'linear-gradient(160deg, #0b3a6f 0%, #0d2b53 60%, #08223f 100%)',
                height: '62px',
                padding: '0 12px 0 10px',
                color: '#FFFFFF',
                display: 'flex',
                alignItems: 'center',
                boxSizing: 'border-box',
                flexShrink: 0,
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '0 2px',
                    width: '100%',
                    position: 'relative',
                }}>
                    <button
                        type="button"
                        onClick={() => setLogoutModalOpen(true)}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            padding: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#FFFFFF',
                        }}
                    >
                        <LogOut size={22} color="#FFFFFF" />
                    </button>

                    <img
                        src={getAppLogoAssetUrl()}
                        alt=""
                        onError={(e) => { e.target.src = getAppLogoFallbackUrl(); }}
                        style={getAppHeaderLogoStyle({
                            width: '150px',
                            height: 'auto',
                            position: 'absolute',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            pointerEvents: 'none',
                        })}
                    />

                    {isDevUrl ? (
                        <button
                            type="button"
                            onClick={() => navigate('/app/payment-list')}
                            style={{
                                padding: '6px 12px',
                                background: '#FFFFFF',
                                border: '1px solid rgba(255,255,255,0.45)',
                                borderRadius: '8px',
                                fontSize: '13px',
                                fontWeight: 700,
                                color: '#0d2b53',
                                cursor: 'pointer',
                            }}
                        >
                            내역
                        </button>
                    ) : (
                        <button
                            type="button"
                            onClick={() => navigate('/app/settings')}
                            aria-label="설정"
                            style={{
                                background: 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                padding: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#FFFFFF',
                            }}
                        >
                            <Settings size={22} color="#FFFFFF" />
                        </button>
                    )}
                </div>
            </div>

            {/* 본문: dev URL → AppDashboard_1, 아니면 AppDashboard */}
            <div style={{ flex: 1, minHeight: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                {isDevUrl ? <AppDashboard_1 hideHeader /> : <AppDashboard hideHeader />}
            </div>

            <AppLogoutConfirmModal
                open={logoutModalOpen}
                onCancel={() => {
                    if (!logoutLoading) setLogoutModalOpen(false);
                }}
                onConfirm={confirmLogout}
                loading={logoutLoading}
            />
        </div>
    );
}

export default AppDashboardPage;
